import "./Asl1.scss";

export const Asl1 = () => (
  <svg viewBox="0 0 472.15 182.18" className="asl1Icon">
    <g>
      <g>
        <g>
          <path
            className="cls-2"
            d="M53.44,1.57c-9.61.12-19.32,1.06-27.44,2.45-9.16,1.57-16.23,3.68-18.76,5.8-1.65,1.38-2.71,2.85-3.35,4.47-.65,1.64-.88,3.45-.89,5.5h0v20.69h50.43V1.58h.01ZM29.85,25.16l-2.33,4.96-2.39-4.96-5.5.46,3.15-4.54-3.15-4.54,5.5.46,2.36-5,2.36,5,5.51-.44-3.15,4.52,3.15,4.52-5.51-.44h0Z"
          />
          <path
            className="cls-2"
            d="M3.01,45.67v33.72h50.43v-33.72H3.01ZM35.36,67.19l-5.51-.44-2.33,4.96-2.39-4.96-5.5.46,3.15-4.54-3.15-4.54,5.5.46,2.36-5,2.36,5,5.51-.44-3.15,4.52,3.15,4.52h0Z"
          />
          <path
            className="cls-2"
            d="M109.06,40.47v-20.69h0c0-2.05-.24-3.86-.89-5.5-.64-1.62-1.69-3.08-3.35-4.47-2.53-2.12-9.6-4.23-18.76-5.8-8.12-1.39-17.83-2.33-27.44-2.45v38.9h50.44ZM82.31,17l2.36-5,2.36,5,5.51-.44-3.15,4.52,3.15,4.52-5.51-.44-2.33,4.96-2.39-4.96-5.5.46,3.15-4.54-3.15-4.54,5.5.46h0Z"
          />
          <path
            className="cls-2"
            d="M109.06,45.67h-50.43v33.72h50.43v-33.72ZM92.53,67.19l-5.51-.44-2.33,4.96-2.39-4.96-5.5.46,3.15-4.54-3.15-4.54,5.5.46,2.36-5,2.36,5,5.51-.44-3.15,4.52,3.15,4.52h0Z"
          />
          <path
            className="cls-5"
            d="M58.63,40.47V1.57c-.87-.01-1.73-.03-2.6-.02-.86,0-1.73.01-2.6.02v38.9H3v5.19h50.43v33.72h5.19v-33.72h50.43v-5.19h-50.43,0Z"
          />
          <path
            className="cls-1"
            d="M29.44,85.78h0c0-.19,0-.44.01-.75l-26.2-1.4c.68,13.99,6.81,26.51,16.29,35.56,9.56,9.13,22.54,14.72,36.79,14.72,13.36,0,25.68-4.94,35.09-13.17,9.18-8.03,15.58-19.19,17.48-31.96h-13.05c-.78,8.35-4.72,15.73-10.59,21.05-5.95,5.38-13.88,8.64-22.53,8.64h0c-9.18,0-17.5-3.66-23.52-9.57-6.02-5.92-9.75-14.09-9.75-23.12h-.02Z"
          />
          <path
            className="cls-4"
            d="M109.63,13.72c-.73-1.85-1.93-3.52-3.8-5.09-2.74-2.29-10.09-4.53-19.5-6.14C77.41.96,66.58-.03,56.03,0c-10.55-.03-21.38.96-30.3,2.49-9.41,1.61-16.76,3.85-19.5,6.14-1.87,1.56-3.07,3.23-3.8,5.09-.72,1.83-.99,3.83-.99,6.07h0v61.16h53.68v-.62h1.81v.62h53.68V19.79h0c0-2.24-.26-4.24-.99-6.07h.01ZM53.44,79.39H3.01V19.79h0c0-2.05.24-3.86.89-5.5.64-1.62,1.69-3.08,3.35-4.47,2.53-2.12,9.6-4.23,18.76-5.8,8.12-1.39,17.83-2.33,27.44-2.45.87-.01,1.73-.03,2.6-.02.86,0,1.73.01,2.6.02,9.61.12,19.32,1.06,27.44,2.45,9.16,1.57,16.23,3.68,18.76,5.8,1.65,1.38,2.71,2.85,3.35,4.47.65,1.64.88,3.45.89,5.5h0v59.6h-55.65Z"
          />
          <polygon
            className="cls-1"
            points="87.02 58.6 84.66 53.6 82.31 58.6 76.8 58.14 79.95 62.68 76.8 67.22 82.31 66.76 84.69 71.72 87.02 66.76 92.53 67.19 89.37 62.68 92.53 58.15 87.02 58.6"
          />
          <polygon
            className="cls-1"
            points="29.85 58.6 27.49 53.6 25.14 58.6 19.63 58.14 22.78 62.68 19.63 67.22 25.14 66.76 27.52 71.72 29.85 66.76 35.36 67.19 32.2 62.68 35.36 58.15 29.85 58.6"
          />
          <polygon
            className="cls-1"
            points="76.8 25.62 82.31 25.16 84.69 30.12 87.02 25.16 92.53 25.6 89.37 21.08 92.53 16.56 87.02 17 84.66 12 82.31 17 76.8 16.54 79.95 21.08 76.8 25.62"
          />
          <polygon
            className="cls-1"
            points="35.36 16.56 29.85 17 27.49 12 25.14 17 19.63 16.54 22.78 21.08 19.63 25.62 25.14 25.16 27.52 30.12 29.85 25.16 35.36 25.6 32.2 21.08 35.36 16.56"
          />
          <path className="cls-4" d="M56.94,80.33h-1.81v35.68c.6.14,1.2.27,1.81.38v-36.06Z" />
          <path
            className="cls-4"
            d="M40.28,107.79c-5.74-5.63-9.28-13.42-9.28-22.01h0v-.78c0-.25.02-.52.03-.8l.02-.37-29.47-1.68.08,1.4h0c.67,14.47,6.98,27.42,16.77,36.76,9.85,9.4,23.21,15.16,37.87,15.16,13.75,0,26.44-5.08,36.12-13.56,9.68-8.47,16.36-20.33,18.12-33.9h0v-.66h-16.27v.98c-.68,8.07-4.45,15.21-10.12,20.34-5.67,5.13-13.23,8.24-21.48,8.24h0c-1.97,0-3.89-.19-5.76-.53-.61-.11-1.21-.23-1.81-.38-5.72-1.38-10.83-4.27-14.85-8.22h.03ZM62.7,118.46c8.65,0,16.59-3.26,22.53-8.64,5.88-5.32,9.81-12.7,10.59-21.05h13.05c-1.89,12.77-8.3,23.93-17.48,31.96-9.41,8.23-21.73,13.17-35.09,13.17-14.24,0-27.22-5.59-36.79-14.72-9.48-9.04-15.6-21.56-16.29-35.56l26.2,1.4c0,.31-.01.56-.01.75h0c0,9.03,3.73,17.2,9.75,23.12,6.02,5.91,14.34,9.57,23.52,9.57h.02Z"
          />
        </g>
        <path className="cls-3" d="M439.47,29.63h-18.24V4.41h47.82v129.39h-29.57V29.63h-.01Z" />
      </g>
      <g>
        <path
          className="cls-6"
          d="M177.06,108.04h56.54l9.38,25.76h34.79L226.67,1.29h-37.88l-57.2,132.51h34.97l10.5-25.76ZM206.88,34.91l18.38,50.39h-38.72l20.35-50.39h-.01Z"
        />
        <path
          className="cls-6"
          d="M318.09,115.52c-2.31,1.14-5.63,1.71-9.94,1.71-3.06,0-7.08-.75-12.05-2.25s-10.17-3.5-15.61-5.99v20.06c2.38,1.21,4.75,2.2,7.13,2.99,2.38.79,4.88,1.47,7.5,2.04,5.25,1.14,10.78,1.71,16.6,1.71,11.63,0,20.63-2.51,27-7.54,6.38-5.03,9.56-12.16,9.56-21.39,0-5.88-1.5-10.81-4.5-14.8-3-3.98-7.72-7.4-14.16-10.24l-9.75-4.08c-10.13-4.36-15.19-7.93-15.19-10.72,0-2.28.91-4,2.72-5.17s4.41-1.76,7.78-1.76c3.81,0,8.08.76,12.8,2.27,4.72,1.52,9.92,3.79,15.61,6.82v-19.8c-4.81-2.46-9.64-4.28-14.49-5.45-4.84-1.17-10.11-1.75-15.8-1.75-10.31,0-18.63,2.59-24.94,7.78-6.31,5.18-9.47,12.04-9.47,20.58,0,11.19,8.53,20.36,25.6,27.5l3,1.23c6.06,2.59,9.92,4.63,11.58,6.12,1.66,1.49,2.48,3.15,2.48,4.98,0,2.28-1.16,3.98-3.47,5.12v.03Z"
        />
        <rect className="cls-6" x="363.28" y="1.29" width="28.04" height="132.51" />
        <path
          className="cls-6"
          d="M7.74,163.25l-7.74,18.71h4.42l1.45-3.75h7.27l1.45,3.75h4.41l-7.74-18.71h-3.52ZM6.91,174.78l2.53-6.65h.1l2.54,6.65h-5.18.01Z"
        />
        <polygon
          className="cls-6"
          points="25.16 178.24 33 163.87 33 163.25 19.45 163.25 19.45 166.92 26.9 166.92 26.9 166.97 19.05 181.35 19.05 181.96 33.19 181.96 33.19 178.29 25.16 178.29 25.16 178.24"
        />
        <rect className="cls-6" x="34.87" y="163.25" width="4.15" height="18.71" />
        <polygon
          className="cls-6"
          points="41.74 181.96 52.7 181.96 52.7 178.26 45.91 178.26 45.91 174.29 51.53 174.29 51.53 170.7 45.91 170.7 45.91 166.96 52.7 166.96 52.7 163.25 41.74 163.25 41.74 181.96"
        />
        <polygon
          className="cls-6"
          points="66.84 170.54 66.95 174.6 66.84 174.6 65.48 172.76 57.85 163.25 54.81 163.25 54.81 181.96 58.98 181.96 58.98 174.64 58.9 170.4 59 170.4 60.37 172.29 67.95 181.96 71 181.96 71 163.25 66.84 163.25 66.84 170.54"
        />
        <path
          className="cls-6"
          d="M89.46,172.48c0-1.57-.26-2.93-.79-4.08s-1.24-2.11-2.13-2.88-1.91-1.33-3.04-1.71c-1.13-.38-2.3-.56-3.51-.56h-6.41v18.71h6.74c1.13,0,2.24-.2,3.33-.59s2.06-.99,2.93-1.78,1.57-1.78,2.09-2.97c.52-1.19.79-2.57.79-4.14h0ZM84.83,175.14c-.31.73-.71,1.33-1.21,1.79-.5.46-1.03.8-1.59,1.01s-1.09.32-1.59.32h-2.69v-11.3h2.69c.5,0,1.03.1,1.59.29.56.19,1.09.51,1.59.93.5.43.9.99,1.21,1.7.31.7.46,1.57.46,2.6s-.15,1.93-.46,2.66h0Z"
        />
        <path
          className="cls-6"
          d="M95.89,163.25l-7.74,18.71h4.42l1.45-3.75h7.27l1.45,3.75h4.41l-7.74-18.71h-3.52ZM95.06,174.78l2.53-6.65h.1l2.54,6.65h-5.18,0Z"
        />
        <polygon
          className="cls-6"
          points="113.28 166.96 117.83 166.96 117.83 181.96 121.98 181.96 121.98 166.96 126.51 166.96 126.51 163.25 113.28 163.25 113.28 166.96"
        />
        <path
          className="cls-6"
          d="M137.95,175.06c0,1.02-.29,1.85-.88,2.47-.59.62-1.38.93-2.37.93-.63,0-1.2-.14-1.68-.42-.49-.28-.87-.67-1.14-1.18-.27-.51-.41-1.11-.41-1.8v-11.81h-4.16v11.46c0,1.51.3,2.82.91,3.94s1.47,1.98,2.58,2.6c1.11.61,2.41.92,3.91.92s2.83-.31,3.94-.93,1.96-1.48,2.56-2.6c.6-1.11.9-2.42.9-3.93v-11.46h-4.15v11.81h-.01Z"
        />
        <polygon
          className="cls-6"
          points="142.9 166.96 147.44 166.96 147.44 181.96 151.59 181.96 151.59 166.96 156.13 166.96 156.13 163.25 142.9 163.25 142.9 166.96"
        />
        <polygon
          className="cls-6"
          points="156.92 181.96 167.87 181.96 167.87 178.26 161.08 178.26 161.08 174.29 166.71 174.29 166.71 170.7 161.08 170.7 161.08 166.96 167.87 166.96 167.87 163.25 156.92 163.25 156.92 181.96"
        />
        <path
          className="cls-6"
          d="M188.39,163.25l-7.5,18.12v-3.11h-6.74v-15.01h-4.16v18.71h15.08l1.45-3.75h7.27l1.45,3.75h4.41l-7.74-18.71h-3.52ZM187.56,174.78l2.53-6.65h.1l2.54,6.65h-5.18,0Z"
        />
        <path
          className="cls-6"
          d="M219.96,165.52c-.9-.76-1.91-1.33-3.04-1.71s-2.3-.56-3.51-.56h-6.41v18.71h6.74c1.13,0,2.24-.2,3.33-.59s2.06-.99,2.93-1.78,1.57-1.78,2.09-2.97.79-2.57.79-4.14-.26-2.93-.79-4.08-1.24-2.11-2.13-2.88h0ZM218.25,175.14c-.31.73-.71,1.33-1.21,1.79-.5.46-1.03.8-1.59,1.01s-1.09.32-1.59.32h-2.69v-11.3h2.69c.5,0,1.03.1,1.59.29.56.19,1.09.51,1.59.93.5.43.9.99,1.21,1.7.31.7.46,1.57.46,2.6s-.15,1.93-.46,2.66h0Z"
        />
        <polygon
          className="cls-6"
          points="224.37 181.96 235.33 181.96 235.33 178.26 228.54 178.26 228.54 174.29 234.16 174.29 234.16 170.7 228.54 170.7 228.54 166.96 235.33 166.96 235.33 163.25 224.37 163.25 224.37 181.96"
        />
        <polygon className="cls-6" points="241.61 163.25 237.45 163.25 237.45 181.96 248.35 181.96 248.35 178.26 241.61 178.26 241.61 163.25" />
        <path
          className="cls-6"
          d="M267.39,163.25l-7.5,18.12v-3.11h-6.74v-15.01h-4.16v18.71h15.08l1.45-3.75h7.27l1.45,3.75h4.41l-7.74-18.71h-3.52ZM266.56,174.78l2.53-6.65h.1l2.54,6.65h-5.18,0Z"
        />
        <path
          className="cls-6"
          d="M297.95,174.08c-.36-.63-.81-1.14-1.34-1.54s-1.07-.72-1.6-.95-.98-.4-1.35-.51c-.27-.08-.62-.18-1.04-.32-.42-.14-.83-.31-1.24-.51-.41-.21-.75-.46-1.03-.76-.28-.3-.42-.66-.42-1.07,0-.53.2-.93.6-1.22.4-.29.84-.43,1.33-.43.42,0,.79.09,1.11.29.33.19.59.42.81.69s.36.51.44.74l3.83-1.56c-.3-.71-.74-1.36-1.3-1.94s-1.25-1.05-2.08-1.4c-.82-.35-1.77-.52-2.84-.52-1.21,0-2.27.22-3.17.67-.9.44-1.61,1.06-2.11,1.85-.51.79-.76,1.72-.76,2.77s.23,1.91.69,2.62c.46.72,1.06,1.3,1.8,1.76.74.46,1.53.83,2.37,1.1.35.11.73.23,1.16.37s.83.31,1.22.5.71.44.96.72c.25.29.38.63.38,1.04,0,.36-.1.68-.31.97s-.48.52-.82.69-.71.25-1.11.25c-.51,0-.96-.12-1.37-.37s-.75-.56-1.03-.93c-.28-.38-.49-.77-.62-1.17l-3.96,1.66c.27.84.75,1.61,1.44,2.31s1.51,1.26,2.47,1.68c.96.41,1.98.62,3.07.62,1.23,0,2.32-.26,3.29-.78s1.72-1.22,2.27-2.09.83-1.85.83-2.91c0-.91-.19-1.67-.55-2.3l-.02-.02Z"
        />
        <path
          className="cls-6"
          d="M305.57,163.25l-7.74,18.71h4.42l1.45-3.75h7.27l1.45,3.75h4.41l-7.74-18.71h-3.52ZM304.74,174.78l2.53-6.65h.1l2.54,6.65h-5.18,0Z"
        />
        <polygon className="cls-6" points="321.49 163.25 317.33 163.25 317.33 181.96 328.23 181.96 328.23 178.26 321.49 178.26 321.49 163.25" />
        <path
          className="cls-6"
          d="M339.26,175.06c0,1.02-.29,1.85-.88,2.47-.59.62-1.38.93-2.37.93-.63,0-1.2-.14-1.68-.42-.49-.28-.87-.67-1.14-1.18-.27-.51-.41-1.11-.41-1.8v-11.81h-4.16v11.46c0,1.51.3,2.82.91,3.94s1.47,1.98,2.58,2.6c1.11.61,2.41.92,3.91.92s2.83-.31,3.94-.93c1.11-.62,1.96-1.48,2.56-2.6.6-1.11.9-2.42.9-3.93v-11.46h-4.15v11.81h0Z"
        />
        <polygon
          className="cls-6"
          points="344.2 166.96 348.74 166.96 348.74 181.96 352.9 181.96 352.9 166.96 357.43 166.96 357.43 163.25 344.2 163.25 344.2 166.96"
        />
        <polygon
          className="cls-6"
          points="358.22 181.96 369.17 181.96 369.17 178.26 362.38 178.26 362.38 174.29 368.01 174.29 368.01 170.7 362.38 170.7 362.38 166.96 369.17 166.96 369.17 163.25 358.22 163.25 358.22 181.96"
        />
        <polygon className="cls-6" points="381.95 163.25 377.78 163.25 377.78 181.96 388.69 181.96 388.69 178.26 381.95 178.26 381.95 163.25" />
        <rect className="cls-6" x="389.47" y="163.25" width="4.15" height="18.71" />
        <path
          className="cls-6"
          d="M404.44,174.61h5.12c0,.74-.19,1.4-.58,1.98-.39.58-.92,1.03-1.61,1.36-.68.33-1.46.5-2.33.5-.8,0-1.55-.14-2.23-.43-.69-.29-1.28-.69-1.79-1.22s-.9-1.14-1.18-1.86c-.28-.71-.42-1.5-.42-2.37,0-1.18.26-2.19.77-3.05.52-.86,1.21-1.52,2.09-1.99s1.86-.7,2.94-.7c.91,0,1.72.14,2.44.42s1.3.63,1.73,1.07l1.59-3.73c-.85-.53-1.76-.91-2.75-1.17s-1.99-.38-3.01-.38c-1.46,0-2.79.25-4.01.74s-2.27,1.17-3.16,2.05-1.57,1.9-2.06,3.07-.72,2.43-.72,3.8.24,2.61.72,3.76c.48,1.15,1.15,2.15,2.02,3.01.87.85,1.9,1.52,3.08,1.99s2.48.71,3.9.71c1.72,0,3.21-.35,4.48-1.04,1.27-.69,2.26-1.64,2.96-2.85s1.05-2.58,1.05-4.11v-3.01h-9.04v3.45h0Z"
        />
        <path
          className="cls-6"
          d="M425.64,175.06c0,1.02-.29,1.85-.88,2.47-.59.62-1.38.93-2.37.93-.63,0-1.2-.14-1.68-.42-.49-.28-.87-.67-1.14-1.18-.27-.51-.41-1.11-.41-1.8v-11.81h-4.16v11.46c0,1.51.3,2.82.91,3.94s1.47,1.98,2.58,2.6c1.11.61,2.41.92,3.91.92s2.83-.31,3.94-.93c1.11-.62,1.96-1.48,2.56-2.6.6-1.11.9-2.42.9-3.93v-11.46h-4.15v11.81h0Z"
        />
        <path
          className="cls-6"
          d="M444.65,172.3c.6-.98.9-2.08.9-3.3s-.29-2.28-.86-3.14-1.35-1.5-2.32-1.95c-.98-.44-2.08-.67-3.31-.67h-6.75v18.71h4.16v-6.46h1.55c.28,0,.54-.02.8-.04l3.71,6.5h4.7l-4.55-7.69c.83-.53,1.5-1.18,1.98-1.98v.02ZM441.11,170.89c-.24.39-.58.69-1.02.9s-.95.32-1.52.32h-2.09v-5.15h1.94c.91,0,1.65.23,2.22.7.56.46.84,1.1.84,1.89,0,.51-.12.95-.36,1.34h0Z"
        />
        <rect className="cls-6" x="448.34" y="163.25" width="4.15" height="18.71" />
        <path
          className="cls-6"
          d="M464.39,163.25h-3.5l-7.74,18.71h4.42l1.45-3.75h7.27l1.45,3.75h4.41l-7.74-18.71h-.02ZM460.05,174.78l2.53-6.65h.1l2.54,6.65h-5.18.01Z"
        />
      </g>
    </g>
  </svg>
);
